import { render, staticRenderFns } from "./TopicFaqs.vue?vue&type=template&id=f32dd6fa&scoped=true&"
import script from "./TopicFaqs.vue?vue&type=script&lang=js&"
export * from "./TopicFaqs.vue?vue&type=script&lang=js&"
import style0 from "./TopicFaqs.vue?vue&type=style&index=0&id=f32dd6fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32dd6fa",
  null
  
)

export default component.exports